import React, { InputHTMLAttributes } from "react";

import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { cn } from "@/lib/utils";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  id: string;
  error?: string | string[] | undefined | null;
  description?: string;
  required?: boolean;
  optional?: boolean;
  children?: React.ReactNode;
  labelSide?: React.ReactNode; // For right-side label content
};

const LabeledField = ({
  label,
  id,
  type,
  value,
  placeholder,
  className,
  description,
  error,
  children,
  required,
  optional,
  labelSide,
  onChange,
  onBlur,
  ...props
}: Props) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label htmlFor={id}>
          {label}{" "}
          {required && <span className="text-red-500">*</span>}
          {optional && " (optional)"}
        </Label>
        {/* conditionally render component on the right side of label */}
        {labelSide}
      </div>
      {/* Render custom input if provided */}
      {children ? (
        <>{children}</>
      ) : (
        <Input
          id={id}
          type={type}
          value={value}
          placeholder={placeholder}
          className={cn(className, error ? "border-red-500" : "")}
          onChange={onChange}
          onBlur={onBlur}
          {...props}
        />
      )}
      {error && (
        <div className="text-sm text-red-500">
          {Array.isArray(error) ? (
            <p style={{ whiteSpace: "pre-line" }}>{error.join("\n")}</p>
          ) : (
            <p>{error}</p>
          )}
        </div>
      )}
      {description && <p className="text-xs text-gray-500">{description}</p>}
    </div>
  );
};

export default LabeledField;
